import { createReducer } from 'reduxsauce';
import { PackageTypes } from './actions';

const requestState = {
  packages: [],
  payments: [],
  loading: true,
  error: null
};

const INITIAL_STATE = {
  ...requestState
};

const fetchSuccess = (state = INITIAL_STATE, actions) => ({
  ...state,
  packages: actions.data.result,
  loading: false,
  error: null
});

const fetchFailure = (state = INITIAL_STATE, actions) => ({
  ...state,
  error: actions.error
});

const fetchPaymentSuccess = (state = INITIAL_STATE, actions) => ({
  ...state,
  payments: actions.data.result,
  loading: false,
  error: null
});

const fetchPaymentFailure = (state = INITIAL_STATE, actions) => ({
  ...state,
  error: actions.error
});

export const HANDLERS = {
  [PackageTypes.PACKAGES_FETCH_FAILURE]: fetchFailure,
  [PackageTypes.PACKAGES_FETCH_SUCCESS]: fetchSuccess,
  [PackageTypes.PAYMENT_LIST_FETCH_SUCCESS]: fetchPaymentSuccess,
  [PackageTypes.PAYMENT_LIST_FETCH_FAILURE]: fetchPaymentFailure
};

export const packageReducer = createReducer(INITIAL_STATE, HANDLERS);
